"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _getEarlyRequesterResultPromise = _interopRequireDefault(require("../getEarlyRequesterResultPromise"));

var _constants = require("./constants");

var API_BASE = 'hubs/v1/hubs';

var portalId = _hubspot.default.get();

var SCOPES_URI = 'hubs2/v1/scopes/hub';

var HubAPI =
/*#__PURE__*/
function () {
  function HubAPI() {
    (0, _classCallCheck2.default)(this, HubAPI);
  }

  (0, _createClass2.default)(HubAPI, null, [{
    key: "get",
    value: function get() {
      return (0, _getEarlyRequesterResultPromise.default)('hubs') || _apiClient.default.get(API_BASE + "/" + portalId);
    }
  }, {
    key: "setAccountName",
    value: function setAccountName(_ref) {
      var accountName = _ref.accountName;
      return _apiClient.default.put(API_BASE, {
        data: {
          id: portalId,
          accountName: accountName
        }
      });
    }
  }, {
    key: "setHubValue",
    value: function setHubValue(options) {
      return _apiClient.default.put(API_BASE, {
        data: (0, _extends2.default)({
          id: portalId
        }, options)
      });
    }
  }, {
    key: "getSuggestedAccountName",
    value: function getSuggestedAccountName() {
      return _apiClient.default.get(API_BASE + "/" + portalId + "/suggested-account-name");
    }
  }, {
    key: "getPortalScopes",
    value: function getPortalScopes() {
      return _apiClient.default.get(SCOPES_URI + "/" + portalId + "/filter", {
        query: {
          scopes: _constants.PORTAL_SCOPES_TO_CHECK
        }
      });
    }
  }]);
  return HubAPI;
}();

exports.default = HubAPI;
module.exports = exports.default;